@use "styles" as *;

.me-popover-column {
  display: block;
  flex: 1;

  @include remove-first-and-last-child-margins;
}
